
import { inject, Injectable } from '@angular/core';
import { CommandHandlerFor, Http, L10n } from '@skylab-angular-shared/core';
import { ApiConfig, Command, CommandHandler, ConsoleLogger, HttpService, L10nBase, TaggedUrl, Tags } from '@skylab-shared/core';
import { downloadFileDirectly, fillPlaceholders } from '@skylab-shared/utils';

export interface InventoryStocktakingDownloadDocumentCommandParams {
    documentId: number;
    downloadDirectly?: boolean;
    config: {
        password?: string | null;
        compress?: boolean | null;
        ecoMode?: boolean | null;
    };
}

export interface InventoryStocktakingDownloadDocumentCommandResult { }

export class InventoryStocktakingDownloadDocumentCommand extends Command<InventoryStocktakingDownloadDocumentCommandParams, InventoryStocktakingDownloadDocumentCommandResult | undefined> { }

@CommandHandlerFor(InventoryStocktakingDownloadDocumentCommand)
@Injectable({ providedIn: 'root'})
export class InventoryStocktakingDownloadDocumentCommandHandler implements CommandHandler<InventoryStocktakingDownloadDocumentCommand, InventoryStocktakingDownloadDocumentCommandParams, InventoryStocktakingDownloadDocumentCommandResult | undefined> {
    #url = TaggedUrl.join('inventory/stocktaking/:documentId/printing', [Tags.Api]);
    #logger = new ConsoleLogger(this.constructor.name);

    #http = inject(Http) as HttpService;
    #l10n = inject(L10n) as L10nBase;


    public async handleAsync({ params }: InventoryStocktakingDownloadDocumentCommand): Promise<InventoryStocktakingDownloadDocumentCommandResult | undefined> {
        const inNewWindow = !(params?.config.compress || params?.downloadDirectly);
        let newWindow!: Window;

        try {
            if (inNewWindow) {
                newWindow = window.open('about:blank', '_blank')!;
                newWindow.document.write(this.#l10n.instant('business.document.common.download-file.waiting-message'));
            }

            const { data } = await this.#http.post(fillPlaceholders(this.#url, { documentId: params?.documentId }), { ...params?.config });

            const targetUrl = `${ApiConfig.baseUrl}${data.url}`;

            if (inNewWindow) {
                newWindow.location.href = targetUrl;
            } else {
                downloadFileDirectly(targetUrl);
            }
        } catch (err) {
            newWindow?.close();
            this.#logger.error(err);
            throw err;
        }

        return undefined;
    }
}
